import { render, staticRenderFns } from "./WineShow_Mobile.vue?vue&type=template&id=1c403619&scoped=true&"
import script from "./WineShow_Mobile.vue?vue&type=script&lang=js&"
export * from "./WineShow_Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c403619",
  null
  
)

export default component.exports